<template>
  <div id="geqmodalterms" class="modal modal-geq" :class="{ 'is-active': active }">
    <div class="modal-background" @click.prevent="closeForm()" />
    <div class="modal-card">
      <div class="modal-form">
        <div class="modal-card-head">
          <p class="modal-card-title" v-text="title" />
          <a
            class="modal-card-close bg-transparent"
            href="#"
            aria-label="close"
            @click.prevent="closeForm()"
          >
            <i class="fa fa-times fa-lg" />
          </a>
        </div>
        <form @submit.prevent="validateBeforeSubmit">
          <section class="modal-card-body">
            <h3 v-text="labels.labelTerms" />
            <br />
            <div v-html="terms" />
          </section>
        </form>
      </div>
    </div>
  </div>
</template>
<script>
import EventBus from '../../vue-functions/event-bus';
import { closeModal } from '../../../js/modals/closeModal';
export default {
  props: ['labels'],
  data() {
    return {
      active: false,
      terms: '',
      title: ''
    };
  },
  created: function () {
    EventBus.$on('TOGGLE_TERMS_MODAL', (terms, title) => {
      this.terms = terms;
      this.title = title;
      document.documentElement.classList.add('is-clipped');
      this.show();
    });
  },
  mounted() {
    this.closeModal(this.closeForm);
  },
  methods: {
    show() {
      this.active = true;
    },
    closeForm() {
      this.submitted = false;
      this.active = false;
      document.documentElement.classList.remove('is-clipped');
      document.querySelector('.modal-card-body').parentElement.classList.remove('scroll-more');
    },
    closeModal
  }
};
</script>
